import React, { useEffect, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { login as loginRequest } from "../api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  // Randomise the field name so password managers don't autofill the shared
  // partner logins into the wrong account.
  const [pwField, setPwField] = useState("passwordField");
  useEffect(() => {
    setPwField(`passwordField_${Math.random().toString(36).slice(2, 8)}`);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError("");
    setBusy(true);
    try {
      const { token, pages } = await loginRequest(username.trim(), password);
      onLogin(token, username.trim(), pages);
    } catch (err) {
      setError(err.message || "Unable to sign in. Please try again.");
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <div className="login-card">
        <div className="login-art">
          <DotLottieReact src="/dil1.json" loop autoplay style={{ width: 250 }} />
        </div>

        <h1 className="login-title">Diligence</h1>
        <p className="login-sub">Partner dashboard</p>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={submit} autoComplete="off" className="login-form">
          {/*
            iOS will autocapitalise and autocorrect a text input by default,
            and the logins here are two letters - exactly what it likes to
            "fix" into a word. Lowercasing on change catches the capital but
            not the substitution, so the guards have to be on the field itself.
          */}
          <input
            className="login-input"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
            autoComplete="off"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            enterKeyHint="next"
          />
          <input
            className="login-input"
            type="password"
            placeholder="Password"
            name={pwField}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            enterKeyHint="go"
          />
          <button className="login-btn" type="submit" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="login-foot">Diligence Intl Ltd</div>
        <p className="login-privacy">
          Your session and display settings stay in this browser. We do not use cookies.
        </p>
      </div>
    </div>
  );
}
